//mui imports==========
import useCommonStyles from '../../../../../commonStyles';
import { Box } from '@mui/system';
import Typography from '@mui/material/Typography';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined'; //=====================

const BidderDetails = ({ bidder, bidderIndex, deleteBidder, children }) => {
	const commonStyleClasses = useCommonStyles();
	return (
		<Box className={commonStyleClasses.basicOutlinedBox} style={{ width: '30%' }}>
			<div style={{ display: 'flex', justifyContent: 'space-between' }}>
				<Typography
					fontWeight={600}
					variant="h4"
					color="primary.grey"
					style={{ marginBottom: '2rem' }}
				>
					{bidder}
				</Typography>

				<DeleteOutlinedIcon
					color="primary"
					onClick={() => deleteBidder(bidder)}
					className={commonStyleClasses.icon}
				/>
			</div>
			{children}
		</Box>
	);
};

export default BidderDetails;
